import { db, oid } from '../firebase';

export const getWebsiteRoot = () =>
  db.ref(`appData/${oid}/website/root`);

export const getWebsiteServices = () =>
  db.ref(`appData/${oid}/website/services`);

export const getWebsiteTestimonials = () =>
  db.ref(`appData/${oid}/website/testimonials`);

export const getWebsitePortfolio = () =>
  db.ref(`appData/${oid}/website/portfolio`);

export const updateWebsiteRoot = (updates) =>
  db.ref(`appData/${oid}/website/root`)
    .update(updates);

export const createWebsiteService = (service) =>
  db.ref(`appData/${oid}/website/services`)
    .push(service)

export const deleteWebsiteService = (id) =>
  db.ref(`appData/${oid}/website/services/${id}`)
    .remove();

export const updateWebsiteService = (id, updates) =>
  db.ref(`appData/${oid}/website/services/${id}`)
    .update(updates);

export const createWebsiteTestimonial = (testimonial) =>
  db.ref(`appData/${oid}/website/testimonials`)
    .push(testimonial)

export const deleteWebsiteTestimonial = (id) =>
  db.ref(`appData/${oid}/website/testimonials/${id}`)
  .remove();

export const updateWebsiteTestimonial = (id, updates) =>
  db.ref(`appData/${oid}/website/testimonials/${id}`)
    .update(updates);

export const createWebsitePortfolio = (portfolio) =>
  db.ref(`appData/${oid}/website/portfolio`)
    .push(portfolio)

export const deleteWebsitePortfolio = (id) =>
  db.ref(`appData/${oid}/website/portfolio/${id}`)
  .remove();

export const updateWebsitePortfolio = (id, updates) =>
  db.ref(`appData/${oid}/website/portfolio/${id}`)
    .update(updates);

export const createWebsiteImages = (websiteImages) =>
  db.ref('websiteImages').set(websiteImages);

export const getWebsiteImages = () =>
  db.ref('websiteImages');

export const getHeroImages = () =>
  db.ref('websiteImages/hero');

export const getContactImages = () =>
  db.ref('websiteImages/contact');



// WEBPACK FOOTER //
// ./src/firebase/database/website.js